import {
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import MainCard from "ui-component/cards/MainCard";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import axios from "axios";

const UpdateWorkingDetails = ({ alumniDetails, hasMultipleCurrent, setAlumniDetails, alumniId, setOpenEdit }) => {
    const RequestId = useRequestIdGenerater();
    const Role = localStorage.getItem("role")

    const [industriesList, setIndustriesList] = useState([])
    const [functionAreaList, setFuctionalAreaList] = useState([])

    const { rendomRequestId, generateTimeStamp } = useTimeStamp();
    const getMonth = (dateStr) => {
        if (!dateStr) return "";
        return (new Date(dateStr).getMonth() + 1).toString();
    };

    const getYear = (dateStr) => {
        if (!dateStr) return "";
        return new Date(dateStr).getFullYear().toString();
    };

    const parseAlumniDetail = (detail) => ({
        id: detail?.id ?? "",
        organizationName: detail?.organizationName ?? "",
        joiningDate: detail?.joiningDate ?? "",
        present: hasMultipleCurrent ? false : true,
        endDate: detail?.endDate ?? "",
        yearOfExperience: detail?.yearOfExperience ?? 0,
        designation: detail?.designation ?? "",
        industries: detail?.industries ?? "",
        functionalArea: detail?.functionalArea ?? "",
        detailRole: detail?.detailRole ?? "",
        otherFunctionalArea: detail?.otherFunctionalArea ?? '',
        otherIndustries: detail?.otherIndustries ?? '',
        startMonth: getMonth(detail?.startMonth),
        startYear: getYear(detail?.startYear),
        endMonth: getMonth(detail?.endMonth),
        endYear: getYear(detail?.endYear),
    });

    const initialValues = {
        workingDetails: Array.isArray(alumniDetails)
            ? alumniDetails.map(parseAlumniDetail)
            : [parseAlumniDetail(alumniDetails ?? {})]
    };
    const handleSubmit = (values) => {
        const payload = {
            ...values.workingDetails?.[0] || {},
            otherFunctionalArea: values.workingDetails?.[0].otherFunctionalArea ? values.workingDetails?.[0].otherFunctionalArea : "",
            otherIndustries: values.workingDetails?.[0].otherIndustries ? values.workingDetails?.[0].otherIndustries : "",
        }
        axios
            .put(`/v1/alumni/update-individual/working-details?alumniId=${alumniId}`, payload, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        "serviceToken"
                    )}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        values?.workingDetails[0].joiningDate,
                        values?.workingDetails[0].organizationName + rendomRequestId
                    ),
                },
            })
            .then((value) => {
                setAlumniDetails(value?.data?.data)
                generateTimeStamp();
                dispatch(
                    openSnackbar({
                        open: true,
                        message: "Updated Successfully.",
                        variant: "alert",
                        alert: {
                            color: "success",
                        },
                        close: false,
                    })
                );
                setOpenEdit(false)

            })
            .catch((error) => {
                if (error.response.status === 404) {
                    generateTimeStamp();
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: error.response.data.Msg,
                            variant: "alert",
                            alert: {
                                color: "error",
                            },
                            close: false,
                        })
                    );
                } else {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: "Something went wrong",
                            variant: "alert",
                            alert: {
                                color: "error",
                            },
                            close: false,
                        })
                    );
                    generateTimeStamp();
                }
            });
    };


    const fetchData = async (endpoint, processResponse) => {
        let url = `/v1/${endpoint}`;
        const instituteId =
            Role === "ROLE_COLLEGE_ADMIN" ? localStorage.getItem("instituteId") : "";
        if (instituteId) {
            url += `?instituteId=${instituteId}`;
        }

        try {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        "serviceToken"
                    )}`,
                    "Content-Type": "application/json",
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
                    ),
                },
            });

            processResponse(response);
        } catch (err) {
            console.log(err);
        }
    };

    const getIndustriesList = () => {
        fetchData("master/industries", (response) => {
            setIndustriesList(response?.data?.data);
        });
    };
    const getFunctionalArea = () => {
        fetchData("master/functional-area", (response) => {
            setFuctionalAreaList(response?.data?.data);
        });
    };

    useEffect(() => {
        getIndustriesList();
        getFunctionalArea();
        generateTimeStamp();
    }, []);

    console.log(hasMultipleCurrent, 'hasMultipleCurrent')

    return (
        <MainCard>
            {/* {hasMultipleCurrent && (
                <Typography color="error" sx={{ fontSize: "0.9rem", mb: 2 }}>
                    Please provide the end date for this position. You have already marked another experience as your current position.
                </Typography>
            )} */}

            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
                {({ values, handleChange, touched, errors, setFieldValue }) => (
                    <Form>
                        <FieldArray
                            name="workingDetails"
                            render={(arrayHelpers) => (
                                <>
                                    {values.workingDetails?.length > 0 &&
                                        values.workingDetails.map((items, i) => (
                                            <React.Fragment key={i}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            id={`workingDetails.${i}.organizationName`}
                                                            name={`workingDetails.${i}.organizationName`}
                                                            label="Organization Name"
                                                            value={items.organizationName}
                                                            onChange={handleChange}
                                                            error={
                                                                touched.workingDetails?.[i]?.organizationName &&
                                                                Boolean(errors.workingDetails?.[i]?.organizationName)
                                                            }
                                                            helperText={
                                                                touched.workingDetails?.[i]?.organizationName &&
                                                                errors.workingDetails?.[i]?.organizationName
                                                            }
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            fullWidth
                                                            id={`workingDetails.${i}.designation`}
                                                            name={`workingDetails.${i}.designation`}
                                                            label="Designation"
                                                            value={items.designation}
                                                            onChange={handleChange}
                                                            error={
                                                                touched.workingDetails?.[i]?.designation &&
                                                                Boolean(errors.workingDetails?.[i]?.designation)
                                                            }
                                                            helperText={
                                                                touched.workingDetails?.[i]?.designation &&
                                                                errors.workingDetails?.[i]?.designation
                                                            }
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <FormControl
                                                            fullWidth
                                                            error={
                                                                touched.workingDetails?.[i]?.industries &&
                                                                Boolean(errors.workingDetails?.[i]?.industries)
                                                            }
                                                        >
                                                            <InputLabel id={`industry-label-${i}`}>Industry</InputLabel>
                                                            <Select
                                                                labelId={`industry-label-${i}`}
                                                                id={`workingDetails.${i}.industries`}
                                                                name={`workingDetails.${i}.industries`}
                                                                value={items?.industries || ""}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    const selectedValue = e.target.value;
                                                                    setFieldValue(
                                                                        `workingDetails.${i}.otherIndustries`,
                                                                        selectedValue === "Other" ? "" : null
                                                                    );
                                                                }}
                                                                label="Industry"
                                                            >
                                                                <MenuItem value="">
                                                                    <em>None</em>
                                                                </MenuItem>
                                                                {industriesList?.map((data) => (
                                                                    <MenuItem key={data?.name} value={data?.name}>
                                                                        {data?.name}
                                                                    </MenuItem>
                                                                ))}
                                                                <MenuItem value="Other">Other</MenuItem>
                                                            </Select>
                                                            <FormHelperText>
                                                                {touched.workingDetails?.[i]?.industries &&
                                                                    errors.workingDetails?.[i]?.industries}
                                                            </FormHelperText>
                                                        </FormControl>

                                                        {items?.industries === "Other" && (
                                                            <TextField
                                                                fullWidth
                                                                label="Enter Industry"
                                                                value={items.otherIndustries}
                                                                onChange={(e) =>
                                                                    setFieldValue(
                                                                        `workingDetails.${i}.otherIndustries`,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                margin="dense"
                                                            />
                                                        )}
                                                    </Grid>

                                                    <Grid item xs={12} md={4}>
                                                        <FormControl
                                                            fullWidth
                                                            error={
                                                                touched.workingDetails?.[i]?.functionalArea &&
                                                                Boolean(errors.workingDetails?.[i]?.functionalArea)
                                                            }
                                                        >
                                                            <InputLabel id={`functional-label-${i}`}>
                                                                Functional Area
                                                            </InputLabel>
                                                            <Select
                                                                labelId={`functional-label-${i}`}
                                                                id={`workingDetails.${i}.functionalArea`}
                                                                name={`workingDetails.${i}.functionalArea`}
                                                                value={items?.functionalArea || ""}
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    const selectedValue = e.target.value;
                                                                    setFieldValue(
                                                                        `workingDetails.${i}.otherFunctionalArea`,
                                                                        selectedValue === "Other" ? "" : null
                                                                    );
                                                                }}
                                                                label="Functional Area"
                                                            >
                                                                <MenuItem value="">
                                                                    <em>None</em>
                                                                </MenuItem>
                                                                {functionAreaList?.map((data) => (
                                                                    <MenuItem key={data?.name} value={data?.name}>
                                                                        {data?.name}
                                                                    </MenuItem>
                                                                ))}
                                                                <MenuItem value="Other">Other</MenuItem>
                                                            </Select>
                                                            <FormHelperText>
                                                                {touched.workingDetails?.[i]?.functionalArea &&
                                                                    errors.workingDetails?.[i]?.functionalArea}
                                                            </FormHelperText>
                                                        </FormControl>

                                                        {items?.functionalArea === "Other" && (
                                                            <TextField
                                                                fullWidth
                                                                label="Enter Functional Area"
                                                                value={items.otherFunctionalArea}
                                                                onChange={(e) =>
                                                                    setFieldValue(
                                                                        `workingDetails.${i}.otherFunctionalArea`,
                                                                        e.target.value
                                                                    )
                                                                }
                                                                margin="dense"
                                                            />
                                                        )}
                                                    </Grid>

                                                    <Grid item xs={12} md={8}>
                                                        <TextField
                                                            fullWidth
                                                            multiline
                                                            rows={2}
                                                            id={`workingDetails.${i}.detailRole`}
                                                            name={`workingDetails.${i}.detailRole`}
                                                            label="Job Description"
                                                            value={items.detailRole}
                                                            onChange={handleChange}
                                                            error={
                                                                touched.workingDetails?.[i]?.detailRole &&
                                                                Boolean(errors.workingDetails?.[i]?.detailRole)
                                                            }
                                                            helperText={
                                                                touched.workingDetails?.[i]?.detailRole &&
                                                                errors.workingDetails?.[i]?.detailRole
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography sx={{ p: 1 }}>Start Date</Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} md={6}>
                                                                <FormControl
                                                                    fullWidth
                                                                    error={
                                                                        touched.workingDetails?.[i]?.startMonth &&
                                                                        Boolean(errors.workingDetails?.[i]?.startMonth)
                                                                    }
                                                                >
                                                                    <InputLabel>Month</InputLabel>
                                                                    <Select
                                                                        name={`workingDetails.${i}.startMonth`}
                                                                        value={items.startMonth || ""}
                                                                        onChange={handleChange}
                                                                        label="Month"
                                                                    >
                                                                        {[
                                                                            "January",
                                                                            "February",
                                                                            "March",
                                                                            "April",
                                                                            "May",
                                                                            "June",
                                                                            "July",
                                                                            "August",
                                                                            "September",
                                                                            "October",
                                                                            "November",
                                                                            "December",
                                                                        ].map((month, index) => (
                                                                            <MenuItem key={index} value={index + 1}>
                                                                                {month}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                    <FormHelperText>
                                                                        {touched.workingDetails?.[i]?.startMonth &&
                                                                            errors.workingDetails?.[i]?.startMonth}
                                                                    </FormHelperText>
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={6} md={6}>
                                                                <FormControl
                                                                    fullWidth
                                                                    error={
                                                                        touched.workingDetails?.[i]?.startYear &&
                                                                        Boolean(errors.workingDetails?.[i]?.startYear)
                                                                    }
                                                                >
                                                                    <InputLabel>Year</InputLabel>
                                                                    <Select
                                                                        name={`workingDetails.${i}.startYear`}
                                                                        value={items.startYear || ""}
                                                                        onChange={handleChange}
                                                                        label="Year"
                                                                        MenuProps={{
                                                                            PaperProps: {
                                                                                style: {
                                                                                    maxHeight: 200,
                                                                                },
                                                                            },
                                                                        }}
                                                                    >
                                                                        {Array.from({ length: 30 }, (_, idx) => {
                                                                            const year = new Date().getFullYear() - idx;
                                                                            return (
                                                                                <MenuItem key={year} value={year}>
                                                                                    {year}
                                                                                </MenuItem>
                                                                            );
                                                                        })}
                                                                    </Select>
                                                                    <FormHelperText>
                                                                        {touched.workingDetails?.[i]?.startYear &&
                                                                            errors.workingDetails?.[i]?.startYear}
                                                                    </FormHelperText>
                                                                </FormControl>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} md={4} sx={{ p: 0 }}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    name={`workingDetails.${i}.present`}
                                                                    checked={items.present}
                                                                    onChange={handleChange}
                                                                />

                                                            }
                                                            label="Present"
                                                        />
                                                    </Grid>
                                                    {!items.present && (
                                                        <Grid item xs={12}>
                                                            <Typography sx={{ p: 1 }}>End Date</Typography>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={6} md={6}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={
                                                                            touched.workingDetails?.[i]?.endMonth &&
                                                                            Boolean(errors.workingDetails?.[i]?.endMonth)
                                                                        }
                                                                    >
                                                                        <InputLabel>Month</InputLabel>
                                                                        <Select
                                                                            name={`workingDetails.${i}.endMonth`}
                                                                            value={items.endMonth || ""}
                                                                            onChange={handleChange}
                                                                            label="Month"
                                                                        >
                                                                            {[
                                                                                "January",
                                                                                "February",
                                                                                "March",
                                                                                "April",
                                                                                "May",
                                                                                "June",
                                                                                "July",
                                                                                "August",
                                                                                "September",
                                                                                "October",
                                                                                "November",
                                                                                "December",
                                                                            ].map((month, index) => (
                                                                                <MenuItem key={index} value={index + 1}>
                                                                                    {month}
                                                                                </MenuItem>
                                                                            ))}
                                                                        </Select>
                                                                        <FormHelperText>
                                                                            {touched.workingDetails?.[i]?.endMonth &&
                                                                                errors.workingDetails?.[i]?.endMonth}
                                                                        </FormHelperText>
                                                                    </FormControl>
                                                                </Grid>

                                                                <Grid item xs={6} md={6}>
                                                                    <FormControl
                                                                        fullWidth
                                                                        error={
                                                                            touched.workingDetails?.[i]?.endYear &&
                                                                            Boolean(errors.workingDetails?.[i]?.endYear)
                                                                        }
                                                                    >
                                                                        <InputLabel>Year</InputLabel>
                                                                        <Select
                                                                            name={`workingDetails.${i}.endYear`}
                                                                            value={items.endYear || ""}
                                                                            onChange={handleChange}
                                                                            label="Year"
                                                                            MenuProps={{
                                                                                PaperProps: {
                                                                                    style: {
                                                                                        maxHeight: 200,
                                                                                    },
                                                                                },
                                                                            }}
                                                                        >
                                                                            {Array.from({ length: 30 }, (_, idx) => {
                                                                                const year = new Date().getFullYear() - idx;
                                                                                return (
                                                                                    <MenuItem key={year} value={year}>
                                                                                        {year}
                                                                                    </MenuItem>
                                                                                );
                                                                            })}
                                                                        </Select>
                                                                        <FormHelperText>

                                                                        </FormHelperText>
                                                                    </FormControl>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    )}

                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                </>
                            )}
                        />
                        <Grid
                            item
                            md={12}
                            xs={12}
                            sx={{
                                mt: 2,
                                display: "flex",
                                justifyContent: "flex-end",
                            }}
                        >
                            <Button variant="contained" color="secondary" type="button" onClick={() => setOpenEdit(false)}>Close</Button>
                            <Button variant="contained" color="primary" type="submit" sx={{ ml: 2 }}>
                                Update
                            </Button>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </MainCard>
    );
};

export default UpdateWorkingDetails;
